import React from "react";
/* import shape1 from "../../images/rsvp/image-1.jpg";
import shape2 from "../../images/rsvp/image-2.jpg";
import RSVPFrom from "../RSVPFrom/RSVPFrom"; */
import shape2 from "../../images/rsvp/pngtree-wedding-favor-box-with-ribbon-png-image_15612877.png";

interface RsvpSectionProps {
  rClass?: string;
}

const RsvpSection: React.FC<RsvpSectionProps> = ({ rClass }) => {
  return (
    <section className={`wpo-contact-section ${rClass || ""}`}>
      <div className="container-fluid">
        <div className="contact-wrap">
          <div
            className="contact-title wow fadeInUp"
            data-wow-duration="1200ms"
          >
            <h2 style={{ fontSize: "clamp(2rem, 4vw, 3rem)", lineHeight: 1.2 }}>
              Un pequeño detalle
              <br />
              <img
                src={shape2}
                alt="decorative shape"
                /* className="hover-image" */
                style={{ maxWidth: "min(250px, 20vw)", width: "auto" }}
              />
              {/* <img src={shape1} alt="decorative shape" className="hover-image" />
              <img
                src={shape2}
                alt="decorative shape"
                className="hover-image s2"
              /> */}
            </h2>
            
            <p>
              Para nosotros, lo más importante es poder <b>compartir este momento con ustedes. Su presencia en nuestra boda es el mejor regalo que podríamos recibir. </b>
              <br />
              <br />
              Si alguien desea tener algún detalle con nosotros, agradeceremos mucho cualquier aportación a nuestra alcancía para esta nueva etapa que comenzamos. 
              Si desean hacerlo, con gusto podemos compartirles los datos.
              <br />


            </p>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="wpo-contact-section-wrapper wow fadeInRightSlow"
                data-wow-duration="1200ms"
              >
                {/* <div className="wpo-contact-form-area">
                  <RSVPFrom />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RsvpSection;
